import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export interface UserManagementCriteria {
  companyName: string;
  fullName: string;
  role: string;
  parentCompanyId: string;
  participantType: string;
}

export interface UserManagementSearchState {
  criteria: UserManagementCriteria;
  page: number;
  pageSize: number;
  hasSearched: boolean;
}

export const defaultUserManagementCriteria: UserManagementCriteria = {
  companyName: "",
  fullName: "",
  role: "",
  parentCompanyId: "",
  participantType: "",
};

export const defaultUserManagementSearchState: UserManagementSearchState = {
  criteria: defaultUserManagementCriteria,
  page: 0,
  pageSize: 25,
  hasSearched: false,
};

export const userManagementSearchAtom = atom<UserManagementSearchState>({
  key: RecoilKeys.UserManagementSearch,
  default: defaultUserManagementSearchState,
});
